import * as csv2json from 'csvjson-csv2json';

export function mapCsvToJson(csv) {
    return csv2json(csv, { parseNumbers: true });
}
